<template>
  <div class="control is-vertical">
    <div class="control is-grouped">
      <p class="control is-expanded">
        <textarea :class="{'textarea': true, 'is-danger': errors.has('message')}" name="tips" id="tips" type="text" placeholder="Internal Tips" v-model="tips.message" v-validate data-vv-rules="required"></textarea>
        <span v-show="errors.has('tips')" class="help is-danger">{{ errors.first('tips') }}</span>
      </p>
    </div>
    <div class="control is-grouped">
      <p class="control is-expanded">
        <vue-dropzone ref="dropzone" id="dropzone" :options="dropzoneOptions" @vdropzone-queue-complete="vdSuccess" @vdropzone-sending="vdSendingEvent"></vue-dropzone>
      </p>
    </div>
    <div class="is-clearfix">
      <a :class="{'button': true, 'is-info': true, 'is-disabled': errors.any() || inProgress, 'is-loading': inProgress, 'is-pulled-right': true}" @click="save">Save</a>
    </div>
  </div>
</template>

<script>
  import message from '../../utils/message'
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  export default {
    props: {
      service: {
        type: Object
      }
    },
    data () {
      return {
        tips: {
          service_id: '',
          message: '',
          history_id: '',
          attachments: 0
        },
        dropzoneOptions: {
          url: this.$store.state.config.apiURL + '/services/history/files',
          maxFilesize: 10,
          acceptedFiles: 'image/*,application/pdf,.doc,.docx,.csv,.xls,.xlsx,.txt,.eml,.log,.xml,.json',
          autoProcessQueue: false,
          dictDefaultMessage: 'Upload Files (max size 10MB)',
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.config.token.access_token
          },
          addRemoveLinks: true
        },
        inProgress: false
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.tips.service_id = this.service.id
      })
    },
    methods: {
      save () {
        this.$validator.validateAll().then(() => {
          if (this.errors.items.length === 0) {
            if (this.$refs.dropzone.getQueuedFiles().length > 0) {
              this.tips.attachments = 1
            }
            this.inProgress = true
            this.$http.post(this.$store.state.config.apiURL + '/services/tips', this.tips).then((response) => {
              this.tips.history_id = response.body.id
              if (this.$refs.dropzone.getQueuedFiles().length > 0) {
                this.tips.attachments = 1
                this.$refs.dropzone.processQueue()
              } else {
                this.$emit('reload')
                this.message('success', 'Success', 'The internal tips was successfully registered')
                this.tips.message = ''
                this.inProgress = false
                this.$validator.reset()
              }
            }, (response) => {
              this.message('danger', 'Error', response.body)
            })
          }
        })
      },
      vdSuccess (file, xhr, formData) {
        this.$emit('reload')
        this.message('success', 'Success', 'The internal tips was successfully registered')
        this.tips.message = ''
        this.inProgress = false
        this.$validator.reset()
        this.$refs.dropzone.removeAllFiles(true)
      },
      vdSendingEvent (file, xhr, formData) {
        formData.append('service_id', this.tips.service_id)
        formData.append('history_id', this.tips.history_id)
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      }
    },
    components: {
      vueDropzone: vue2Dropzone
    }
  }
</script>



// WEBPACK FOOTER //
// Tips.vue?cf3edfd6